/**
 * MAP enforcement rule card per scope §6.6.1 (post scope-doc clarification
 * commit 2868958). Atlas Day 3a P1.
 *
 * Surface: "ISG enforces MAP on N of M brands. Flag-and-report posture —
 * engine surfaces violations to buyers rather than blocking sales."
 * Substrate-driven N/M from brands.enforces_map=true count vs total active
 * brands. D5 conditional (Day 1) applies at N=0 (current substrate state
 * per Atlas Day 2 P0 #10).
 *
 * Click handler navigates to inspect view per Atlas Day 2.5 P1 URL routing.
 */

import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import type { MapEnforcementSubstrate } from '../../../lib/atlas/transformationRowSubstrate';

export interface MapEnforcementCardProps {
  substrate: MapEnforcementSubstrate;
}

export default function MapEnforcementCard({ substrate }: MapEnforcementCardProps): JSX.Element {
  const navigate = useNavigate();
  const { enforcesMapCount, totalActiveBrands } = substrate;
  const surfaceLine =
    enforcesMapCount > 0
      ? `ISG enforces MAP on ${enforcesMapCount} of ${totalActiveBrands} brands. Flag-and-report posture — engine surfaces violations to buyers rather than blocking sales.`
      : `ISG has not yet configured MAP enforcement on any of ${totalActiveBrands} active brands. Substrate ready — flag-and-report posture activates when brands.enforces_map populates.`;
  return (
    <button
      type="button"
      data-sub-region-id="map-enforcement"
      onClick={() => navigate('/admin/engine-atlas/inspect/map-enforcement')}
      className="w-full text-left border border-border-subtle bg-surface-0 rounded-md p-3 hover:border-accent transition-colors cursor-pointer"
    >
      <div className="flex items-start gap-2">
        <ShieldCheck size={16} className="text-ink-secondary flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-ink-bright">MAP enforcement</h3>
          <p className="text-xs text-ink-secondary mt-1">{surfaceLine}</p>
        </div>
      </div>
    </button>
  );
}
